import {
  CONSULTANTS_LOADING_START,
  CONSULTANTS_LOADING_SUCCESS,
  CONSULTANTS_LOADING_FAILED,
  CHANGE_CONSULTANTS_PAGE,
  CHANGE_CONSULTANTS_LIMIT,
  //Поиск
  CHANGE_CONSULTANTS_SEARCH,
  START_CONSULTANTS_SEARCH,
  CLEAR_CONSULTANTS_SEARCH,
  CHANGE_CONSULTANTS_SORTING,
} from '../actions/consultantsList';

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  ready: false,
  loading: false,
  consultants: [],
  cons_total: 0,
  cons_limit: 15,
  cons_activePage: 1,
  cons_search: '',
  cons_activeSearch: '',
  sorting: {
    sort: 'created_at',
    order: true,
  }
};

export default function (state = INITIAL_STATE, action) { 
  switch (action.type) {
    case CONSULTANTS_LOADING_START:
      return {
        ...state,
        ready: false,
        loading: true,
        consultants: [],
        cons_total: 0,
      };
    case CONSULTANTS_LOADING_SUCCESS:
      return {
        ...state,
        ready: true,
        loading: false,
        consultants: action.payload.consultants.consultants,
        cons_total: parseInt(action.payload.consultants.total, 10),
      };
    case CONSULTANTS_LOADING_FAILED:
      return {
        ...state,
        ready: false,
        loading: false,
      };
    case CHANGE_CONSULTANTS_PAGE:
      return {
        ...state,
        cons_activePage: action.payload.activePage,
      };
    case CHANGE_CONSULTANTS_LIMIT:
      return {
        ...state,
        cons_limit: action.payload.activeLimit,
        cons_activePage: INITIAL_STATE.cons_activePage,
      };
    //Поиск
    case CHANGE_CONSULTANTS_SEARCH: 
      return {
        ...state,
        cons_search: action.payload.value
      };
    case START_CONSULTANTS_SEARCH:
      return {
        ...state,
        cons_activeSearch: action.payload.value,
        cons_activePage: INITIAL_STATE.cons_activePage,
      };
    case CLEAR_CONSULTANTS_SEARCH: 
      return {
        ...state,
        cons_activeSearch: INITIAL_STATE.cons_activeSearch,
        cons_search: INITIAL_STATE.cons_search,
        cons_activePage: INITIAL_STATE.cons_activePage,
      };
    //Сортировка
    case CHANGE_CONSULTANTS_SORTING:
      return {
        ...state,
        sorting: action.payload,
        cons_activePage: INITIAL_STATE.cons_activePage,
      };
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}